import { render } from "./SideBar.vue?vue&type=template&id=42acda9d&scoped=true"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"

import "./SideBar.vue?vue&type=style&index=0&id=42acda9d&scoped=true&lang=css"
import "./SideBar.vue?vue&type=style&index=1&id=42acda9d&lang=css"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42acda9d"]])

export default __exports__